import React, { useState } from "react";
import { Box, Flex, Image } from "@chakra-ui/react";
import { UserSessionDropdown } from "@/components/UserSessionDropdown";
import iconMessage from "@/images/IconMessage.svg?url";
import FeedbackModal from "@/js/components/FeedbackModal";
import { DistrictSupportWindow } from "@/js/components/DistrictSupportWindow";
import { useSelectedClassroomStore } from "@/stores/v2/selectedClassroomStore";

interface Props {
	classroomName?: string;
}

export function NavRightActions(props: Props): JSX.Element {
	const [showDistrictContactDetails, setShowDistrictContactDetails] = useState<boolean>(false);
	const [showFeedbackModal, setShowFeedbackModal] = useState<boolean>(false);
	const classroomId = useSelectedClassroomStore().stableIdV1;

	const handleOpenDistrictContactDetails = (): void => {
		setShowDistrictContactDetails(true);
	};

	const closeDistrictContactDetails = (): void => {
		setShowDistrictContactDetails(false);
	};

	const toggleFeedbackModal = (): void => {
		setShowFeedbackModal(!showFeedbackModal);
	};

	return (
		<Flex gap={5} alignItems={"center"} mx={5} zIndex={99}>
			<button className="NavRightActions_item" onClick={handleOpenDistrictContactDetails}>
				<Image className="NavRightActions_icon" src="/static/images/Icon_Support.svg" alt="" />
				<span className="NavRightActions_description">Support</span>
			</button>
			{classroomId && (
				<button className="NavRightActions_item NavRightActions_itemLight" onClick={toggleFeedbackModal}>
					<Image className="NavRightActions_icon" src={iconMessage} alt="" />
					<span className="NavRightActions_description">Send Feedback</span>
				</button>
			)}
			<Box height={"20px"} borderRight={"2px solid rgba(255, 255, 255, 0.3)"} />
			<UserSessionDropdown />
			<DistrictSupportWindow open={showDistrictContactDetails} okay={closeDistrictContactDetails} />
			{showFeedbackModal && props.classroomName && <FeedbackModal classroomName={props.classroomName} handleClose={toggleFeedbackModal} />}
		</Flex>
	);
}
